<div
  [style.scroll-padding-top.px]="scrollPaddingTop()"
  class="timeline-container tw-snap-y tw-snap-mandatory tw-overscroll-y-contain tw-scroll-smooth tw-overflow-y-auto tw-flex tw-flex-col tw-w-full tw-gap-8 tw-font-inter tw-px-4 tw-relative tw-min-h-0"
>
  <app-events-timeline-header
    #eventsTimelineHeader
    class="tw-snap-start tw-snap-always"
    [isFloating]="true"
    [selectedFilter]="selectedFilter()"
    [searchTerm]="searchTerm()"
    [filtersCount]="filtersCount()"
    [loadingCount]="loadingFiltersCount()"
    (criteriaChanged)="onCriteriaChanged($event)"
    (archivedOpened)="openArchivedEventsWizard()"
    (createEventClicked)="createEvent()"
    (onDisplayFloatingHeader)="onDisplayFloatingHeader($event)"
  ></app-events-timeline-header>

  @if (isInitialLoading() || isRefreshing() || loadingInitialPersonas()) {
    <app-events-timeline-skeleton-card></app-events-timeline-skeleton-card>
  } @else if (showEmptyState()) {
    <app-events-timeline-empty-state
      [mode]="emptyStateMode()"
      [imageSrc]="emptyStateImageSrc()"
      [filterLabel]="selectedFilterLabel()"
      [showCreateButton]="emptyStateMode() === 'all'"
      [canCreate]="canCreate()"
      createButtonLabel="Create first event"
      (createClicked)="createEvent()"
    ></app-events-timeline-empty-state>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-0 tw-bg-transparent tw-pb-4">
      @for (event of events(); track event.id) {
        <app-event-wrapper
          class="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-snap-start tw-snap-always"
          [model]="getEventWrapperModel(event, $last)"
          (modalStateChanged)="setModalOpen($event)"
          (archiveUpdateChanged)="setArchiveUpdate($event)"
          (personaAction)="onPersonaAction($event)"
          (cloneConfirmed)="onHeaderCloneConfirmed($event)"
          (archiveConfirmed)="onHeaderArchiveConfirmed($event)"
          (restoreConfirmed)="onHeaderRestoreConfirmed($event)"
          (bannerChanged)="onBannerChanged($event)"
          (powerUpClicked)="onPowerUpClicked($event)"
        ></app-event-wrapper>
      }
      <div #loadMoreTrigger class="tw-h-4 tw-w-full"></div>
    </div>
  }

  @if (isPaginating()) {
    <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
      <div class="tw-w-6 tw-h-6 tw-border-2 tw-border-blue-600 tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
    </div>
  }
</div>